import {Component, Input, OnInit} from '@angular/core';
import {SummaryModel} from '../../entity/summary.model';
import {WithSummaryModel} from '../../entity/dto/plain/withSummary.model';
import {BaseView} from '../../../core/view/base.view';
import {
    AgendaEventPlanningDownloadPayload
} from '../../../agenda/modules/event/impl/service/payload/agendaEventPlanningDownload.payload';
import {MomentAdapter} from '../../../../shared/utils/moment.utils';
import {PayloadWithId} from '../../../core/service/payload/payloadWithId';

@Component({
    template: `<p>This should never be visible</p>`
})
export abstract class ItemSummaryPlainEntityOrSummaryComponent
    <Summary extends SummaryModel, Plain extends WithSummaryModel<Summary>> extends BaseView implements OnInit {

    @Input() displayBusinessContextLabel = false;
    @Input() entity: Summary | Plain;
    @Input() clickable = false;

    get summary(): Summary {
       return this.isPlain(this.entity) ? this.summaryFromPlain() : this.summaryFromSummary();
    }

    get plain(): Plain {
        return this.isPlain(this.entity) ? (this.entity as Plain) : undefined;
    }

    ngOnInit() {
    }

    isPlain(entity: Plain | Summary) {
        return !!(entity as Plain).summary;
    }

    protected summaryFromPlain(): Summary {
        return (this.entity as Plain).summary;
    }

    protected summaryFromSummary(): Summary {
        return (this.entity as Summary);
    }

    buildPayloadWithId = (): PayloadWithId => {
        return {
            id: this.summary.id
        };
    }
}
